export const module = {
  info: {
    name: 'voip-mrt-destinations',
    caption: 'voip mrt destinations',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true
}

export default module
